// CE-193: Frontend-only tenant feature flags.
//
// The Pitt tenant is allowed to reopen submitted student surveys before the
// survey end date. This gate is intentionally frontend-only for the UI; the
// backend still enforces the resubmit guard (see the related backend spec).
//
// `tenantKey` is persisted in localStorage during the login/tenant-resolution
// flow (see LoginPage/useTenantInformation) and is typically the email domain
// (e.g. `pitt.edu`). Both the domain and the short key are matched so the flag
// stays aligned with however the Pitt tenant resolves on login.
const PITT_TENANT_KEYS = new Set(['pitt.edu', 'pitt'])

export function isPittTenant (): boolean {
  const key = localStorage.getItem('tenantKey')?.toLowerCase() ?? ''
  return PITT_TENANT_KEYS.has(key)
}

export function isStudentSurveyReopenEnabled (): boolean {
  return isPittTenant()
}
